import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, MapPin, Instagram, Phone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message received. We'll write back soon.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="contact-page" className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
      <p className="overline text-[color:var(--vw-ink-soft)]">Write to us</p>
      <h1 className="font-serif-display text-5xl md:text-7xl italic mt-3">Say Hello</h1>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <form onSubmit={submit} className="md:col-span-7 space-y-6" data-testid="contact-form">
          <label className="block">
            <span className="overline text-[color:var(--vw-ink-soft)]">Name</span>
            <input
              data-testid="contact-name"
              required
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              className="mt-2 block w-full bg-transparent border-b border-[color:var(--vw-beige-dark)] focus:border-[color:var(--vw-ink)] py-2 outline-none font-utility"
            />
          </label>
          <label className="block">
            <span className="overline text-[color:var(--vw-ink-soft)]">Email</span>
            <input
              data-testid="contact-email"
              type="email"
              required
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              className="mt-2 block w-full bg-transparent border-b border-[color:var(--vw-beige-dark)] focus:border-[color:var(--vw-ink)] py-2 outline-none font-utility"
            />
          </label>
          <label className="block">
            <span className="overline text-[color:var(--vw-ink-soft)]">Message</span>
            <textarea
              data-testid="contact-message"
              required
              rows={5}
              value={form.message}
              onChange={e => setForm({ ...form, message: e.target.value })}
              className="mt-2 block w-full bg-transparent border-b border-[color:var(--vw-beige-dark)] focus:border-[color:var(--vw-ink)] py-2 outline-none font-utility resize-none"
            />
          </label>
          <button
            data-testid="contact-submit"
            disabled={loading}
            className="overline px-8 py-4 bg-[color:var(--vw-ink)] text-[color:var(--vw-bg)] hover:opacity-90 disabled:opacity-40 transition-opacity"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>

        <aside className="md:col-span-4 md:col-start-9 space-y-8">
          <div>
            <p className="overline">Studio</p>
            <p className="mt-3 flex items-start gap-3 text-[color:var(--vw-ink-soft)]"><MapPin size={16} className="mt-1" />Bangalore, Karnataka</p>
          </div>
          <div>
            <p className="overline">Email</p>
            <a href="mailto:Vastrawest@gmail.com" className="mt-3 flex items-center gap-3 text-[color:var(--vw-ink-soft)] hover:text-[color:var(--vw-ink)]">
              <Mail size={16} /> Vastrawest@gmail.com
            </a>
          </div>
          <div>
            <p className="overline">Phone</p>
            <a href="tel:+918971087294" data-testid="contact-phone" className="mt-3 flex items-center gap-3 text-[color:var(--vw-ink-soft)] hover:text-[color:var(--vw-ink)]">
              <Phone size={16} /> +91 89710 87294
            </a>
          </div>
          <div>
            <p className="overline">Follow</p>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="mt-3 flex items-center gap-3 text-[color:var(--vw-ink-soft)] hover:text-[color:var(--vw-ink)]">
              <Instagram size={16} /> @vastrawest
            </a>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Contact;
